export default "__VITE_ASSET__DgDfUvDh__"